var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g890",
    transform: "matrix(0.587088,0,0,-0.587088,-51.2946,173.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(1,0,0,1,397.46,294.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M0,0L4.289,-7.892L21.646,-7.892L29.54,0L0,0Z",
    style: {
      fill: "rgb(90,115,149)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "matrix(1,0,0,1,419.106,286.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M0,0L0,-37.958L7.895,-42.248L7.895,7.892L0,0Z",
    style: {
      fill: "rgb(139,157,181)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "matrix(1,0,0,1,95.2603,258.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M0,0L-7.889,6.291L-7.889,-43.85L0,-35.959L0,0Z",
    style: {
      fill: "rgb(232,146,75)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "matrix(1,0,0,1,95.2603,222.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M0,0L-7.889,-7.891L21.653,-7.891L15.362,0L0,0Z",
    style: {
      fill: "rgb(239,179,129)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "matrix(1,0,0,1,136.817,242.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M0,0C-6.113,0 -10.816,4.422 -10.816,11.1C-10.816,17.777 -6.113,22.199 0,22.199C6.115,22.199 10.817,17.777 10.817,11.1C10.817,4.422 6.115,0 0,0M0,35.932C-13.826,35.932 -24.926,25.114 -24.926,11.1C-24.926,-2.915 -13.826,-13.732 0,-13.732C13.827,-13.732 24.927,-2.915 24.927,11.1C24.927,25.114 13.827,35.932 0,35.932",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "matrix(1,0,0,1,264.537,269.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M0,0L0,8.372L-14.108,8.372L-14.108,-38.658L0,-38.658L0,-17.4C0,-8.088 8.278,-5.738 14.11,-6.678L14.11,8.372C8.184,8.372 1.882,6.302 0,0",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "matrix(1,0,0,1,201.329,276.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M0,0C-2.227,1.032 -4.716,1.547 -7.146,1.547C-13.073,1.547 -19.375,-1.463 -21.256,-7.765L-21.256,0.607L-35.364,0.607L-35.364,-46.422L-21.256,-46.422L-21.256,-25.165C-21.256,-16.883 -14.71,-14.115 -9.159,-14.264C-7.513,-8.539 -4.261,-3.594 0,0",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "matrix(1,0,0,1,313.931,251.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M0,0C0,-6.678 -3.574,-9.688 -8.748,-9.688C-13.264,-9.688 -16.932,-6.96 -16.932,-1.129L-16.932,25.678L-31.041,25.678L-31.041,-3.199C-31.041,-15.896 -22.951,-22.669 -13.45,-22.669C-7.243,-22.669 -2.539,-20.412 0,-16.932L0,-21.352L14.109,-21.352L14.109,25.678L0,25.678L0,0Z",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "matrix(1,0,0,1,385.006,278.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M0,0C-6.678,0 -11.005,-2.446 -13.638,-6.208C-16.272,-2.258 -20.41,0 -25.96,0C-32.262,0 -36.401,-2.446 -38.564,-5.644L-38.564,-1.317L-52.673,-1.317L-52.673,-48.347L-38.564,-48.347L-38.564,-21.822C-38.564,-16.273 -35.931,-12.981 -31.228,-12.981C-26.712,-12.981 -24.455,-15.991 -24.455,-20.694L-24.455,-48.347L-10.346,-48.347L-10.346,-21.822C-10.346,-16.273 -7.713,-12.981 -3.01,-12.981C1.505,-12.981 3.763,-15.991 3.763,-20.694L3.763,-48.347L17.872,-48.347L17.872,-19.47C17.872,-7.713 10.817,0 0,0",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "matrix(1,0,0,1,220.429,242.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M0,0C-6.49,0 -11.193,4.421 -11.193,11.476C-11.193,18.53 -6.49,22.951 0,22.951C6.491,22.951 11.193,18.53 11.193,11.476C11.193,4.421 6.491,0 0,0M11.193,53.803L11.193,30.57C8.088,34.144 3.479,36.308 -2.822,36.308C-7.518,36.308 -11.893,34.729 -15.517,32.01C-19.498,29.023 -22.555,24.65 -24.125,19.451C-24.877,16.958 -25.302,14.286 -25.302,11.476C-25.302,-2.539 -15.144,-13.356 -2.822,-13.356C3.479,-13.356 8.088,-11.193 11.193,-7.619L11.193,-12.039L25.302,-12.039L25.302,53.803L11.193,53.803Z",
    style: {
      fill: "rgb(60,60,59)",
      fillRule: "nonzero"
    }
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b5981200595ca153a263ecfc0441e2d.svg";
export { ForwardRef as ReactComponent };